module.exports = __webpack_public_path__ + "static/img/cont60 (7).5959af9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont60 (7).jpg
// module id = CRxo
// module chunks = 0